module.exports = __webpack_public_path__ + "img/achc-logo-w.7f2aeda8.png";